import * as types from './mutation-types.js';
import data from './../api/index.js';
import {cookie} from '../utils/cookie.js';
//获取用户投递简历数
export const getApplyNum = ({commit}, userid) => {
	if (!cookie.getCookie('isShowPop')) {
		cookie.setCookie('isShowPop', true, 1);
		data.hasApplyNum(userid)
			.then(responseData => {
				commit(types.GET_APPLY_NUM, { responseData: responseData});
			}).catch(err => console.log(err));
	}
};



// WEBPACK FOOTER //
// ./src/store/actions.js